import type {
  StreamingDefinitionV1,
  StreamingDefinitionV2,
} from "../models/streaming.js";
import { parseStationV1, parseStationV2 } from "./station.js";

export function parseStreamingDefinitionV1(raw: unknown): StreamingDefinitionV1 {
  const r = (raw ?? {}) as Record<string, unknown>;
  const rawOpen = Array.isArray(r["open"]) ? (r["open"] as unknown[]) : [];
  return {
    live: Boolean(r["live"] ?? false),
    version: typeof r["version"] === "string" ? r["version"] : "",
    open: rawOpen.map(parseStationV1),
  };
}

export function parseStreamingDefinitionV2(raw: unknown): StreamingDefinitionV2 {
  const r = (raw ?? {}) as Record<string, unknown>;
  const rawOpen = Array.isArray(r["open"]) ? (r["open"] as unknown[]) : [];
  const out: StreamingDefinitionV2 = {
    live: Boolean(r["live"] ?? false),
    version: typeof r["version"] === "string" ? r["version"] : "",
    open: rawOpen.map(parseStationV2),
  };
  if (typeof r["country"] === "string") out.country = r["country"].toLowerCase();
  if (typeof r["source"] === "string") out.source = r["source"];
  if (r["updatedAt"] !== undefined && r["updatedAt"] !== null) {
    out.updatedAt = r["updatedAt"] as StreamingDefinitionV2["updatedAt"];
  }
  return out;
}
